<template>
  <div id="main-template" :class="[route_view_css_class]">
    <notifications/>
    <b-navbar id="header" variant="dark" :dark="true" sticky="top" :toggleable="true" :container="false"
              class="navbar-dark">
      <!-- #nav-left -->
      <div id="nav-left">
        <div class="sep">
          <b-navbar-toggle class="navbar-toggler border-0 " target="isales-sidebar"></b-navbar-toggle>
        </div>
        <b-navbar-brand href="./" class="sep mx-2">iSales</b-navbar-brand>
      </div>
      <!-- #nav-center -->
      <RouterView name="header"/>
      <!-- #nav-right -->
      <div id="nav-right" class="agent-cell" @click="goToLogin">
        <p v-if="VECCDAGE" class="m-0 p-0 text-lg">
          <i class="bi bi-person"></i>
          {{ VECCDAGE }}
        </p>
      </div>
    </b-navbar>
    <SiteSidebar/>
    <site-overlay
        :show="LOADING"
        id="main-b-overlay"
    >
      <b-container id="main" fluid class="main">
        <RouterView name="main"/>
      </b-container>
    </site-overlay>
    <footer id="footer" class="footer">
      <b-navbar variant="dark" :dark="true" :container="false" class="nav-tabs">
        <div v-if="PREV_LOCATION" class="sep">
          <b-button variant="dark" @click="back">
            <i class="bi bi-arrow-90deg-left"></i>
          </b-button>
        </div>
        <router-view name="footer"/>
      </b-navbar>
    </footer>
  </div>
</template>

<script lang="ts">
import { RouterView, useRoute, useRouter } from "vue-router";
import SiteSidebar from "./components/SiteSidebar.vue";
import { computed, onMounted } from "vue";
import SiteOverlay from "@/components/SiteOverlay.vue";
import { useRootStore } from "@/stores/root";
import { useLocationStore } from "@/stores/location";
import { useSettingsStore } from "@/stores/settings";
import * as Sentry from "@sentry/vue";

export default {
  components: { SiteOverlay, SiteSidebar, RouterView },
  setup() {
    const rootStore = useRootStore();
    const locationStore = useLocationStore();
    const settingStore = useSettingsStore();
    const router = useRouter();
    const route = useRoute();
    const computed_ = {
      LOADING: computed(() => rootStore.IS_LOADING),
      VECCDAGE: computed(() => rootStore.VECCDAGE),
      PREV_LOCATION: computed(() => locationStore.PREV_LOCATION_get),
      route_view_css_class: computed(() => `view-${String(route.name)}`),
    };

    const methods = {
      async back() {
        await locationStore.back();
      },
      async goToLogin() {
        await router.push({ name: "Login" });
      },
    };

    onMounted(async () => {
      await settingStore.load();
      await rootStore.load();
      Sentry.setUser({ id: rootStore.VECCDAGE });
    });

    return {
      ...computed_,
      ...methods,
    };
  },
};
</script>
